const RenameSchemaFields = (schema, index) => {
  const cloned = JSON.parse(JSON.stringify(schema)); // deep clone

  Object.values(cloned).forEach(rowArray => {
    rowArray.forEach(row => {
      row.rows && Object.values(row.rows).forEach(fields => {
        fields.forEach(field => {
          if (field.name) {
            field.originalName = field.name; 
            field.name = `${field.name}_${index}`; 
          }
        });
      });
    });
  });

  return cloned;
};

export default RenameSchemaFields;